import React from 'react'
import {Helmet} from "react-helmet";
import PageTitle from '../../pagetitle/PageTitle'
import DanismaKurulu from '../../kurullar/DanismaKurulu'


export default function Danisma()
{
    const title = "OKAF Danışma Kurulu - Samsun Üniversitesi";
    const description = "Samsun Üniversitesi ev sahipliğinde gerçekleşecek olan Orta Karadeniz Kariyer Fuarı (OKAF)'ın danışma kurulu hakkında ayrıntılı bilgi için tıklayınız!";
    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
            </Helmet>
            <PageTitle name="Danışma Kurulu"></PageTitle>
            <DanismaKurulu></DanismaKurulu>
        </>
    )
}
